import React, { useEffect, useMemo, useState } from 'react';
import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { Select } from '../../../ui';
import { Table } from '../../../ui/Table';
import { Tip } from '../../../ui/Tip';
import { useResolve } from '../../Container';
import { Flexer, Spacer } from '../../dashboard/elements/LayoutElements';
import { LensReflector } from '../../packages/lens/LensReflector';
import { useEditorSessionObserver } from '../EditorSession';
import { Selection } from '../Selection';
import { cameraFrameSelection } from '../commands/CameraCommands';
import { select } from '../commands/SelectionCommands';
import { Physical } from '../entities/Physical';

const usePhysicals = () => {
    const objects = useResolve(ObjectManager);
    const [tick, setTick] = useState(uuid());
    useEffect(() => objects.on('updated', () => setTick(uuid())), []);
    return useMemo(() => [
        ...Array.from(objects.getAll(Physical)),
    ], [tick]);
};

const wrap = (phys: Physical[]) => phys.map(x => ({ id: x.id, label: x.toHumanString(), object: x }));

const PhysicalInfo = ({ object }: { object: Physical }) => {

    const reflector = useResolve(LensReflector);
    const aspects = reflector.reflect([object]);

    return <Table>
        <Table.Body>
            {aspects.map((aspect, i) =>
                <Table.Row key={i} >
                    <Table.Cell>
                        <Tip text={aspect.description}>
                            <span>{aspect.name}</span>
                        </Tip>
                    </Table.Cell>
                    <Table.Cell>{JSON.stringify(aspect.read(object))}</Table.Cell>
                </Table.Row>
            )}
        </Table.Body>
    </Table>;
};

export const DeveloperLensPanel = () => {

    const dispatch = useResolve(CommandDispatcher);
    const physicals = usePhysicals();
    const selection = useEditorSessionObserver(Selection);

    const selectables = useMemo(() => wrap(physicals), [physicals]);
    const item = selectables.find(x => x.id === selection.firstAndOnly()?.id);

    const onSelect = ({ object }: { object: Physical }) => {
        dispatch(select, [[object.id]]);
        dispatch(cameraFrameSelection);
    };

    return <>
        <Select selected={item} items={wrap(physicals)} onChange={onSelect} />
        <Spacer f={2} />
        <Flexer flex="column" gap="1">
            {item &&
                <PhysicalInfo object={item.object} />
            }
        </Flexer>
    </>;
};
